var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infor fl"},[_c('AllHeader',{attrs:{"label":_vm.lable}}),_c('Allylist')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }